import { isArray } from 'util';
import { ManufacturingOrderFilter } from '../manufacturing-order-filter';

export class ManufacturingOrderFilterBuilder {
  static fromJson(json) {
    return (json)
      ? new ManufacturingOrderFilter(
        json.code,
        json.display
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ManufacturingOrderFilterBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-filter.builder.ts